import React from "react";
import {Link } from 'react-router-dom';


export default function LogoSection() {
    return (
       
    <div className="logoText">
        <Link to="/">
            
            <img className="w-fit h-12 rounded-md   flex justify-center align-middle items-center" src="/assets/icons/SalesHustlTextBlack.JPG" alt="Sales Hustl!" />
        </Link>
    </div>
       
    );

}